import React, { Component } from 'react'
import StoreItemTypeList from './StoreItemTypeList'
import StoreSubItemType from './storeSubItemType'
import MenuItem from './menuItem'
import FoodInfo from './foodInfo'
import { connect } from 'react-redux'
import MyOrder from './myOrder'
import propTypes from 'prop-types';
import { setDeviceLoginPage } from '../../action/action'
import { hCommColors } from '../../JS/setColors'
class HCommerce extends Component {

    componentDidMount() {
        //console.log("Hcommerce componentDidMount")
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room")
        if (SessionToken && (!this.props.guestDetail.locationId || !this.props.guestDetail.guestToken)) {
            console.log("h-commerce widget: no session token");
            if (this.props.currentWidget.widgetType && !room || room === "null") {
                this.props.setDeviceLoginPage(true);
                console.log("room", room);
            } else {
                console.log("there is some bug in guest registration flow.")
            }
        }
        hCommColors(this.props.menuColor);
    }

    getPage = () => {
        switch (this.props.currentPage) {
            case "StoreItemTypeList":
                return < StoreItemTypeList />
            case "StoreSubItemType":
                return < StoreSubItemType />
            case "ItemPage":
                return < MenuItem />
            case "itemInfo":
                return < FoodInfo />
            case "myOrder":
                return < MyOrder />
            default:
                return < StoreItemTypeList />
        }
    }
    render() {
        //console.log("currentPage", this.props.currentPage)
        return (
            <div id="ico-room-svc" class="contentSection tile-section">
                {this.getPage()}
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        currentPage: state.store.Hcommerce.currentPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        menuColor: state.store.home.MenuColor
    }
}

export default connect(
    mapStateToProps,
    {
        setDeviceLoginPage
    }
)(HCommerce);